import { render, staticRenderFns } from "./ParameterDashboard.vue?vue&type=template&id=1c611bbe&scoped=true&"
import script from "./ParameterDashboard.vue?vue&type=script&lang=js&"
export * from "./ParameterDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ParameterDashboard.vue?vue&type=style&index=0&id=1c611bbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c611bbe",
  null
  
)

export default component.exports